import { Control, useWatch } from "react-hook-form";
import { SelectOption } from "@via/utils/interfaces";
import SelectComponent from "@via/components/select/select";
import OperatorSelect from "@via/components/advanced-filter/operator-select";
import ValueInput from "@via/components/advanced-filter/value-input";
import {
  FieldType,
  FieldTypeEnum,
} from "@via/components/advanced-filter/helpers/types";
import { getFieldTypeFromString } from "@via/components/advanced-filter/helpers/utils";
import { TrashIcon } from "@heroicons/react/24/outline";

interface FilterRowProps {
  control: Control<any>;
  index: number;
  fieldOptions: SelectOption[];
  fields: FieldType[];
  onRemove: () => void;
}

export default function FilterRow({
  control,
  index,
  fieldOptions,
  fields,
  onRemove,
}: FilterRowProps) {
  const selectedFieldId = useWatch({
    control,
    name: `filters.${index}.id`,
  });

  // Find the selected field to get its type
  const selectedField = fields.find(field => field.name === selectedFieldId);
  const fieldType = selectedField
    ? getFieldTypeFromString(selectedField.type)
    : FieldTypeEnum.String;

  return (
    <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg border">
      <div className="flex-1 grid grid-cols-3 gap-3">
        {/* Field Selection */}
        <div>
          <label className="mb-2 flex items-center text-sm font-medium leading-6 text-gray-900">
            Field
          </label>
          <SelectComponent
            control={control}
            name={`filters.${index}.id`}
            options={fieldOptions}
            placeholder="Select field..."
            enableClear={false}
          />
        </div>

        {/* Operator Selection */}
        <div>
          <label className="mb-2 flex items-center text-sm font-medium leading-6 text-gray-900">
            Operator
          </label>
          <OperatorSelect
            control={control}
            name={`filters.${index}.operator`}
            fieldType={fieldType}
            placeholder="Select operator..."
            enableClear={false}
          />
        </div>

        {/* Value Input */}
        <div className="-mt-2">
          <ValueInput
            control={control}
            name={`filters.${index}.value`}
            fieldType={fieldType}
            placeholder="Enter value..."
            disabled={!selectedFieldId}
          />
        </div>
      </div>

      {/* Remove Button */}
      <button
        type="button"
        onClick={onRemove}
        className="flex-shrink-0 p-2 mt-6 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition-colors"
        title="Remove filter">
        <TrashIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
